import React, { FunctionComponent } from 'react';
import { SvgIconProps } from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { Variant } from '@mui/material/styles/createTypography';
import { AndroidIcon } from '../icons/AndroidIcon';
import { AppleIcon } from '../icons/AppleIcon';
import { GlobeIcon } from '../icons/GlobeIcon';
import { LinuxIcon } from '../icons/LinuxIcon';
import { PlayStationIcon } from '../icons/PlayStationIcon';
import { WindowsIcon } from '../icons/WindowsIcon';
import { XboxIcon } from '../icons/XboxIcon';
import { Platform } from 'functions/src/types/Platform';

type PlatformIconProps = {
  platform: Platform;
  typographyVariant?: Variant;
};

export function PlatformIcon({
  platform,
  typographyVariant,
}: PlatformIconProps) {
  if (!platform) return null;

  const platformIconMap: {
    [platform in Platform]: FunctionComponent<SvgIconProps>;
  } = {
    web: GlobeIcon,
    android: AndroidIcon,
    apple: AppleIcon,
    windows: WindowsIcon,
    xbox: XboxIcon,
    playstation: PlayStationIcon,
    linux: LinuxIcon,
  };

  const SpecificIcon = platformIconMap[`${platform}`];
  return (
    <>
      {!!typographyVariant ? (
        <Typography variant={typographyVariant} lineHeight={0}>
          <SpecificIcon fontSize={'inherit'} />
        </Typography>
      ) : (
        <SpecificIcon fontSize={'inherit'} />
      )}
    </>
  );
}
